// @flow
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import './TreatmentActionForm.scss';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import _ from 'lodash';
import i18n from 'i18n-js';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  subActionIndex: number,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
  };

@formComponent()
export default class ActionAwardSubscriptionForm extends Component {
  props: Props;

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.subscriptionPayload.planID`}
                {...this.props}
              >
                <Form.Input
                  required
                  label={i18n.t('targets_page.fields.treatment_action_planID')}
                  value={_.get(model.nodes[currentNode].data[subActionIndex], 'meta.subscriptionPayload.planID')}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.subscriptionPayload.numBillingCycles`}
                {...this.props}
              >
                <Form.Input
                  required
                  label={i18n.t('targets_page.fields.treatment_action_numBillingCycles')}
                  value={_.get(model.nodes[currentNode].data[subActionIndex], 'meta.subscriptionPayload.numBillingCycles')}
                  type="number"
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
